
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { toast } from '@/utils/common';
import { iArea, iRegion } from '@/interface/region';
import { getRegionDetail, updateRegion } from '@/api/region';
import { log } from 'console';
import { get } from 'http';

@Component({
  components: {},
})
export default class PopDetail extends Vue {
  @Prop() dialogVisible!: boolean;
  @Prop() id!: number;
  @Prop() type!: string;
  @Emit() close() {}

  private dpObj = {};
  private isEdit = true;
  private updateDetail: iRegion = {
    id: 0,
    name: '',
    popular: false,
    pop_text: '',
    link_text: '',
    queue_text: [],
    rule_coin: {
      std_per_hour: 0,
      hig_per_hour: 0,
      zun_per_hour: 0,
    },
    areas: [],
  };

  rules = {
    std_per_hour: [{ required: true, validator: this.checkStdPerHour }],
    hig_per_hour: [{ required: true, validator: this.checkHigPerHour }],
    zun_per_hour: [{ required: true, validator: this.checkZunPerHour }],
  };
  checkAreas: number[] = [];
  checkStdPerHour(rule: any, value: any, callback: any) {
    const { std_per_hour } = this.updateDetail.rule_coin;
    if (std_per_hour % 10 != 0) {
      return callback(new Error('标配扣费标准必须是整十数字'));
    }
    return callback();
  }
  checkHigPerHour(rule: any, value: any, callback: any) {
    const { hig_per_hour } = this.updateDetail.rule_coin;
    if (hig_per_hour % 10 != 0) {
      return callback(new Error('高配扣费标准必须是整十数字'));
    }
    return callback();
  }
  checkZunPerHour(rule: any, value: any, callback: any) {
    const { zun_per_hour } = this.updateDetail.rule_coin;
    if (zun_per_hour % 10 != 0) {
      return callback(new Error('尊享扣费标准必须是整十数字'));
    }
    return callback();
  }
  async submitForm(formName: any) {
    try {
      (this.$refs[formName] as any).validate((valid: any) => {
        if (valid) {
          this.updateRegion();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async updateRegion() {
    this.updateDetail.queue_text = [];
    this.updateDetail.pop_text = '';
    //判断是否有推荐选区
    if (this.updateDetail.areas && this.updateDetail.areas.length > 0) {
      this.updateDetail.areas.forEach(row => {
        const isExit = this.checkAreas.find((item: number) => {
          return item === row.id;
        });

        if (isExit) {
          row.recommend = true;
        } else {
          row.recommend = false;
        }
      });
    }
    const res = await updateRegion(this.updateDetail);
    if (res && res.code === 0) {
      toast('修改成功', 'success');
      this.$emit('ok');
    } else {
      toast(res.msg, 'error');
    }
  }
  async getDetail(id: number) {
    const res: any = await getRegionDetail(id);
    this.updateDetail = res.data;
    if (this.updateDetail.areas) {
      this.checkAreas = this.updateDetail.areas.map(item => {
        if (item.recommend) {
          return item.id;
        }
        return -1;
      });
    }
  }
  mounted() {
    this.getDetail(this.id);
    this.isEdit = false;
    if (this.type == 'update') {
      this.isEdit = true;
    }
  }
}
